import { ListProperty, ListPropertyEvent } from "../../events/ListProperty";
import { GraphicalElement } from "../graphical/GraphicalElement";

export class UIListProperty<T> extends ListProperty<T>
{
  #graphicalElement:GraphicalElement;
  get graphicalElement(){ return this.#graphicalElement }

  constructor( component:GraphicalElement )
  {
    super();
    this.#graphicalElement = component;
    this.#graphicalElement._addListProperty( this );
  }
}